import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem, ItemType } from '../../models/props.models'

import ModalForm, { ModalFormProps } from '../common/ModalForm.common'

interface ModalCommentProps extends Omit<
  ModalFormProps,
  'value' | 'items' | 'steps' | 'setValue' | 'title' | 'submitLabel'
> {
  comment?: string
}
const ModalComment: React.FC<ModalCommentProps> = (props) => {
  const { t } = useTranslation()
  const { comment } = props

  const [value, setValue] = useState<{ comment: string }>({ comment: comment ?? '' })

  const items: FormItem[] = useMemo(
    () => [
      {
        type: ItemType.text,
        key: 'comment',
        props: {
          label: t('orders:components.modalComment.label'),
          placeholder: t('orders:components.modalComment.placeholder'),
          minRows: 10,
          multiline: true,
        },
      },
    ],
    [t],
  )
  return (
    <ModalForm
      {...props}
      value={value}
      maxWidth="sm"
      setValue={setValue}
      items={items}
      title={
        comment
          ? t('orders:components.modalComment.modifyTitle')
          : t('orders:components.modalComment.addTitle')
      }
      submitLabel={t('global:actions.confirm')}
    />
  )
}

export default ModalComment
